<template>
  <div>
    <Head :title="title" />

    <jet-banner />

    <div class="flex flex-col justify-center min-h-screen">
      <!--  bg-CLIENT_PRIMARY_PINK -->
      <nav
        class="bg-white border-b border-gray-100">
        <!-- Primary Navigation Menu -->
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div class="flex justify-center h-16">
            <div class="flex">
              <div class="sm:-my-px sm:flex sm:items-center">
                <a :href="publicPortalUrl">
                  <img
                    src="/images/zoo-logo.png"
                    class="mr-8 sm:w-32 md:w-72" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <!-- Page Content -->
      <main class="flex-grow">
        <flash-messages />
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script setup>
import { Head, usePage } from '@inertiajs/inertia-vue3'
import JetBanner from '@/Jetstream/Banner'
import FlashMessages from '@/Common/FlashMessages'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
})

const publicPortalUrl = usePage().props.value.portal.publicUrl
</script>
